export const Configuration = {
  useMock: false,
  supportedLanguages: ["en"],
  activeLanguage:"en",
  supportedLanguagesFileNames: {
    "en":"en-US",
    "fr":"fr-fr"
  }
};
